// Unpublished Work © 2020-2025 Deere & Company.

import t from 'tcomb';
import {CustomerType} from '../../../enum/customer-type';
import {SearchQuery} from './search-query';
import {facetGroups} from '../../../enum/facet-groups';

export const facetKeys = {
    CITY: 'city',
    CITIES: 'cities',
    COUNTRY: 'country',
    CUSTOMER_ENTITY_ID: 'customerEntityId',
    CUSTOMER_TYPES: 'customerTypes',
    DBS_NUMBER: 'dbsNumber',
    EMAIL: 'email',
    FIRST_NAME: 'firstName',
    PHONE_NUMBER: 'phoneNumber',
    POSTAL_CODE: 'postalCode',
    REWARDS_NUMBER: 'rewardsNumber',
    STATES: 'states',
    TAX_ID: 'taxId',
    QUERY: 'query',
    ORG_ID: 'orgId',
    CRM_ID: 'crmId'
};

export const SelectedFacets = t.struct({
    city: t.maybe(t.String),
    cities: t.list(t.String),
    country: t.String,
    customerEntityId: t.maybe(t.String),
    customerTypes: t.list(CustomerType),
    dbsNumber: t.maybe(t.String),
    email: t.maybe(t.String),
    firstName: t.maybe(t.String),
    phoneNumber: t.maybe(t.String),
    postalCode: t.maybe(t.String),
    rewardsNumber: t.maybe(t.String),
    states: t.list(t.String),
    taxId: t.maybe(t.String),
    orgId: t.maybe(t.String),
    crmId: t.maybe(t.String),
    query: SearchQuery
}, {
    defaultProps: {
        city: '',
        cities: [],
        country: '',
        customerEntityId: '',
        customerTypes: [],
        dbsNumber: '',
        email: '',
        firstName: '',
        phoneNumber: '',
        postalCode: '',
        rewardsNumber: '',
        states: [],
        taxId: '',
        orgId: '',
        crmId: '',
        query: new SearchQuery({})
    },
    name: 'SelectedFacets',
    strict: true
});

SelectedFacets.prototype.activeFacetGroup = function () {
    const group1 = {
        key: facetGroups.FACET_GROUP_1,
        members:
            [
                this.city,
                this.postalCode,
                this.firstName,
                this.query.searchString,
                this.email,
                this.phoneNumber
            ]
    };
    const group2 = {
        key: facetGroups.FACET_GROUP_2,
        members: [
            this.customerEntityId
        ]
    };
    const group3 = {
        key: facetGroups.FACET_GROUP_3,
        members: [
            this.dbsNumber
        ]
    };
    const group4 = {
        key: facetGroups.FACET_GROUP_4,
        members: [
            this.rewardsNumber
        ]
    };
    const group5 = {
        key: facetGroups.FACET_GROUP_5,
        members: [
            this.taxId
        ]
    };
    const group6 = {
        key: facetGroups.FACET_GROUP_6,
        members: [
            this.orgId
        ]
    };

    const group7 = {
        key: facetGroups.FACET_GROUP_7,
        members: [
            this.crmId
        ]
    };

    const hasActiveGroup = [
        group2,
        group3,
        group4,
        group5,
        group1,
        group6,
        group7
    ].filter((group) => group.members.some((val) => val));

    return hasActiveGroup[0]?.key;
};
